import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { DictionaryEntryModel, DictionaryKey, HxDictionaryService, HxSpendService, HxUiLabelPipe, UiLabel } from 'hx-services';
import { HxDateSelectComponent, HxStoreSelectComponent } from 'hx-component';
import { SpendCategorySearchComponent } from '../spend-category-search/spend-category-search.component';

@Component({
    selector: 'app-spend-new',
    templateUrl: './spend-new.component.html',
    styleUrls: ['./spend-new.component.css'],
  imports: [RouterLink, FormsModule, ReactiveFormsModule, HxStoreSelectComponent, SpendCategorySearchComponent, HxDateSelectComponent, TranslocoPipe, HxUiLabelPipe]
})
export class SpendNewComponent implements OnInit {
  form = new FormGroup({
    spendCategoryCode: new FormControl<string | null>(null, Validators.required),
    storeId: new FormControl<number | null>(null, Validators.required),
    total: new FormControl<number | null>(null, Validators.required),
    date: new FormControl<string | null>(null, Validators.required),
    incomingNumber: new FormControl<string | null>(null),
    payBefore: new FormControl<string | null>(null, Validators.required),
  });
  isLoading = {
    save: false,
    entries: false
  };
  private map = new Map<string, UiLabel>;
  cashFlowCategory?: UiLabel;
  cashFlowCategoryCode?: string;

  constructor(
    private spendService: HxSpendService,
    private toastr: ToastrService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private tr: TranslocoService,
    private dictionaryService: HxDictionaryService
  ) {
  }

  ngOnInit(): void {
    this.loadCashFlowCategory();
  }

  selectSpendCategory(category?: DictionaryEntryModel) {
    if (category) {
      this.form.controls.spendCategoryCode.patchValue(category.code);
      this.cashFlowCategory = this.map.get(category.attributes.code);
      this.cashFlowCategoryCode = category.attributes.code;
    } else {
      this.form.controls.spendCategoryCode.patchValue(undefined);
      this.cashFlowCategory = undefined;
      this.cashFlowCategoryCode = undefined;
    }
  }

  async onSubmitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.value;
      this.isLoading.save = true;
      try {
        await this.spendService.saveSpendStore({
          spendCategoryCode: formModel.spendCategoryCode,
          storeId: formModel.storeId,
          total: formModel.total,
          date: formModel.date,
          incomingNumber: formModel.incomingNumber,
          cashFlowCategoryCode: this.cashFlowCategoryCode,
          payBefore: formModel.payBefore,
        });
        this.toastr.success(this.tr.translate('spend-new.ts.addSuccess'));
        await this.router.navigate(['../'], {relativeTo: this.aRoute});
      } finally {
        this.isLoading.save = false;
      }
    } else {
      this.toastr.warning(this.tr.translate('hx.form.fillRequiredFields'));
    }
  }

  private async loadCashFlowCategory() {
    this.isLoading.entries = true;
    try {
      const entries = await this.dictionaryService.getEntries({ key: DictionaryKey.cashFlows, hierarchy: false});

      entries.forEach(item => {
        this.map.set(item.code, item.title); // JSONB в базе хранится как строка JSON
      });
    } finally {
      this.isLoading.entries = false;
    }
  }
}
